import React, { useState } from 'react';
import ImageGallerywomanemploymentcenter from '../components/ImageGallerywomanemploymentcenter';
import IRCTVDonationCard from "./IRCTVDonationCard";
import { useStats } from '../hooks/useStats';

const IRCWOMEN = () => {
  const { stats, loading } = useStats();
  const [womenQuantity, setWomenQuantity] = useState(1);
  const womenBaseAmount = 900;

  // Format date for display
  const formatDisplayDate = (dateString) => {
    if (!dateString) return '31-Jan-2025';
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString('en-US', { month: 'short' });
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  // Format number with commas
  const formatNumber = (num) => {
    if (!num && num !== 0) return 'Loading...';
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  // Women Empowerment handlers
  const handleWomenIncrease = () => setWomenQuantity(prev => prev + 1);
  const handleWomenDecrease = () => setWomenQuantity(prev => prev > 1 ? prev - 1 : 1);
  const handleWomenQuantityChange = (e) => {
    const value = parseInt(e.target.value) || 1;
    setWomenQuantity(value > 0 ? value : 1);
  };

  const womenTotalAmount = womenQuantity * womenBaseAmount;

  const handlePhoneClick = (phoneNumber) => {
    const cleanedNumber = phoneNumber.replace(/\D/g, '');
    const telLink = `tel:${cleanedNumber}`;
    window.location.href = telLink;
  };

  if (loading) return <div className="loading">Loading statistics...</div>;

  return (
    <>
      <div className="about-us-container">
        <section className="activities-details">
          <button 
            onClick={() => window.history.back()}
            style={{
              marginBottom: '10px',
              padding: '8px 10px',
              backgroundColor: '#255fe8',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              fontSize: '16px',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            ← Back to All Activities
          </button>
          <div className="activity-intro">
            <h2>OUR ACTIVITIES</h2>
            <p>All praise and thanks are due to Allaah Subhaanahu wa Ta'ala, IRC - Islamic Research Centre Education & Welfare Trust is involved in the following Social, Welfare and Charitable activities</p>
          </div>

          <ImageGallerywomanemploymentcenter />

          {/* IRC Women Empowerment Centre */}
          <div className="activity-card">
            <div className="activity-header">
              <h3>IRC WOMEN EMPOWERMENT CENTRE (IWEC)</h3>
            </div>
            <div className="activity-content">
              <p>Empowering Women with Skills, Confidence, and Opportunity
                In communities where women's access to education and independence remains limited, the IRC Women Empowerment Centre (IWEC) is creating real change. Through our three centers—located in Baijipura, Ambar Hill, and Parbhani, we have provided free skill development training to 841 women as of January 2025.
                Our courses include tailoring, fashion designing, calligraphy, cake making, mehendi designing, and more designed not only to build practical skills but also to boost self-worth and open doors to income generation. At our newest center in Parbhani, we've expanded the scope to include Arabic classes, women's counseling, Islamic studies, and micro-enterprise training (Laghu Udyog), further supporting women in becoming confident, self-reliant contributors to their families and communities.
                Each number tells a story of transformation and with your support, we aim to reach many more. Empower a woman, and you uplift an entire generation.
              </p>

              <div className="clinic-card">
                <h4>Centre - 1 - Baijipura</h4>
                <p><strong>Name:</strong> IRC Women Empowerment Centre</p>
                <p><strong>Address:</strong> 2nd Floor, IRC Community Centre, Gali No. 34, Apex Hospital Rd, behind Sikandar Hall, Baijipura, Chhatrapati Sambhajinagar (Aurangabad), Maharashtra 431003</p>
                <p>
                  <strong>Location: </strong>
                  <a href="https://www.google.com/maps/place/IRC+Women+Empowerment+Centre+Baijipura/@19.8829948,75.3394948,2446m/data=!3m1!1e3!4m7!3m6!1s0x3bdba3cbf7d9dd95:0x85770254f44c68dd!8m2!3d19.8829909!4d75.3484302!15sChxJUkMgV29tZW4gRW1wb3dlcm1lbnQgQ2VudHJlkgEQZWR1Y2F0aW9uX2NlbnRlcuABAA!16s%2Fg%2F11s8z7slz1?entry=tts&g_ep=EgoyMDI2MDIxMS4wIPu8ASoASAFQAw%3D%3D&skid=59870d1f-59a0-4f3d-a06c-cfdf559a1846" target="_blank" rel="noopener noreferrer">
                    📍Click here for Location
                  </a>
                </p>
                <p><strong>Date of Inauguration:</strong> 21-Sep-2022</p>
                <p><strong>Courses Offered:</strong> Tailoring, Fashion Desining, Caligraphy, Cake Making & Mehendi Designing etc.</p>
                <p><strong>No. of Students Admitted:</strong> {formatNumber(stats.women_baijipura_students)} (till {formatDisplayDate(stats.women_baijipura_date)})</p>
                <p>
                  <strong>Contact No: </strong>
                  <span
                    className="contact-number"
                    onClick={() => handlePhoneClick('8087-0632-11')}
                    style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
                  >
                    8087-0632-11
                  </span>
                </p>
              </div>

              {/* <div className="clinic-card">
                <h4>Centre - 2 - Ambar Hill</h4>
                <p><strong>Name:</strong> IRC Women Empowerment Centre</p>
                <p><strong>Address:</strong> Gut No. 250, Plot No. 12 & 13, Jatwada Rd, beside Mohammadi Masjid, Ambar Hill, Chhatrapati Sambhajinagar (Aurangabad) - 431008</p>
                <p>
                  <strong>Location: </strong>
                  <a href="https://www.google.com/maps/place/Apex+Superspeciality+Hospital/data=!4m7!3m6!1s0x3bdba298d50bd2af:0xc79047004783e9a6!8m2!3d19.8812498!4d75.3471543!16s%2Fg%2F11byp6kfwk!19sChIJr9IL1Zii2zsRpumDRwBHkMc?authuser=0&hl=en&rclk=1" target="_blank" rel="noopener noreferrer">
                    📍Click here for Location
                  </a>
                </p>
                <p><strong>Date of Inauguration:</strong> NA</p>
                <p><strong>Courses Offered:</strong> Tailoring, Fashion Desining, Caligraphy, Cake Making & Mehendi Designing etc.</p>
                <p><strong>No. of Students Admitted:</strong> {formatNumber(stats.women_ambarhill_students)} (till {formatDisplayDate(stats.women_ambarhill_date)})</p>
                <p>
                  <strong>Contact No: </strong>
                  <span
                    className="contact-number"
                    onClick={() => handlePhoneClick('8087-0632-12')}
                    style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
                  >
                    8087-0632-12
                  </span>
                </p>
              </div> */}

              <div className="clinic-card">
                <h4>Centre - 2 - Parbhani</h4>
                <p><strong>Name:</strong> IRC Women Empowerment Centre</p>
                <p><strong>Address:</strong> H.No. 11 & 12, Haji Hameed Colony, Near Parwa Gate, Dargah Road, Parbhani - 431401</p>
                <p>
                  <strong>Location: </strong>
                  <a href="https://www.google.com/maps/place/IRC+Women+Empowerment+Centre+Parbhani/@19.2704373,76.7262686,2455m/data=!3m2!1e3!4b1!4m6!3m5!1s0x3bd019828782d175:0xf4d790693ce5006c!8m2!3d19.270418!4d76.7447227!16s%2Fg%2F11y7shdb4n?entry=tts&g_ep=EgoyMDI2MDIxMS4wIPu8ASoASAFQAw%3D%3D&skid=cbc36af3-705d-4885-873d-925b77968ec3" target="_blank" rel="noopener noreferrer">
                    📍Click here for Location
                  </a>
                </p>
                <p><strong>Date of Inauguration:</strong> 11-Dec-2024</p>
                <p><strong>Courses Offered:</strong> Tailoring, Fashion Desining, Caligraphy, Cake Making, Mehendi Designing, Arabic Classes, Women Counselling, Islamic Studies & Laghu Udyog etc.</p>
                <p><strong>No. of Students Admitted:</strong> {formatNumber(stats.women_parbhani_students)} (till {formatDisplayDate(stats.women_parbhani_date)})</p>
                <p>
                  <strong>Contact No: </strong>
                  <span
                    className="contact-number"
                    onClick={() => handlePhoneClick('9112-9112-06')}
                    style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
                  >
                    9112-9112-06
                  </span>
                </p>
              </div>

              <div className="clinic-card">
                <h4>Centre - 3 - Ibrahim Park</h4>
                <p><strong>Name:</strong> IRC Women Empowerment Centre</p>
                <p><strong>Address:</strong> Gut No. 33, Soniya Nagar, Ibrahim Park, Satara Deolai Parisar, Beed By Pass Road, Aurangabad. - 431401</p>
                <p>
                  <strong>Location: </strong>
                  <a href="https://www.google.com/maps/place/IRC+Community+Centre+Ibrahim+Park/@19.8515047,75.3068061,256m/data=!3m1!1e3!4m6!3m5!1s0x3bdb9939008d5771:0x78edc41cf90a24d5!8m2!3d19.8515497!4d75.3062471!16s%2Fg%2F11vsdq1xmd?entry=tts&g_ep=EgoyMDI2MDIxMS4wIPu8ASoASAFQAw%3D%3D&skid=6ddb8c95-979f-4230-9c2e-1dab52a734c6" target="_blank" rel="noopener noreferrer">
                    📍Click here for Location
                  </a>
                </p>
                <p><strong>Date of Inauguration:</strong> NA</p>
                <p><strong>Courses Offered:</strong> Tailoring, Fashion Desining, Caligraphy, Cake Making & Mehendi Designing etc.</p>
                <p><strong>No. of Students Admitted:</strong> {formatNumber(stats.women_parbhani_students)} (till {formatDisplayDate(stats.women_parbhani_date)})</p>
                <p>
                  <strong>Contact No: </strong>
                  <span
                    className="contact-number"
                    onClick={() => handlePhoneClick('8087-0632-12')}
                    style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
                  >
                    8087-0632-12
                  </span>
                </p>
              </div>

              {/* Women Empowerment Impact Statistics */}
              {/* <div className="impact-stats">
                <h4>Our Women Empowerment Impact</h4>
                <div className="stats-grid">
                  <div className="stat-item">
                    <span className="stat-number">
                      {formatNumber(
                        (stats.women_baijipura_students || 0) + 
                        (stats.women_ambarhill_students || 0) + 
                        (stats.women_parbhani_students || 0)
                      )}+
                    </span>
                    <span className="stat-label">Women Trained</span>
                  </div>
                  <div className="stat-item">
                    <span className="stat-number">₹1,500</span>
                    <span className="stat-label">Per Student (3 Months)</span>
                  </div>
                  <div className="stat-item">
                    <span className="stat-number">3</span>
                    <span className="stat-label">Active Centers</span>
                  </div>
                </div>
              </div> */}

    {/* Course Benefits Breakdown */}
                            <div className="benefits-breakdown">
                                <h4>What Your Donation Provides</h4>
                                <div className="benefits-grid">
                                    <div className="benefit-item">
                                        <span className="benefit-icon">🧵</span>
                                        <span className="benefit-text">Tailoring & Fashion Training</span>
                                    </div>
                                    <div className="benefit-item">
                                        <span className="benefit-icon">🎨</span>
                                        <span className="benefit-text">Calligraphy & Mehendi Classes</span>
                                    </div>
                                    <div className="benefit-item">
                                        <span className="benefit-icon">🍰</span>
                                        <span className="benefit-text">Baking & Cooking Skills</span>
                                    </div>
                                    <div className="benefit-item">
                                        <span className="benefit-icon">📚</span>
                                        <span className="benefit-text">Educational Materials</span>
                                    </div>
                                    <div className="benefit-item">
                                        <span className="benefit-icon">🕌</span>
                                        <span className="benefit-text">Islamic Studies & Arabic</span>
                                    </div>
                                    <div className="benefit-item">
                                        <span className="benefit-icon">💼</span>
                                        <span className="benefit-text">Career Counseling</span>
                                    </div>
                                </div>
                            </div>

            </div>

            {/* Women Empowerment Donation Card */}
            <IRCTVDonationCard
              title="IRC WOMEN EMPOWERMENT CENTRE (IWEC)"
              subtitle="Empower Women, Transform Communities"
              description="Your donation provides comprehensive 3-month skill development training to women. Every ₹900 sponsors one woman's education in tailoring, fashion design, calligraphy, baking, and other valuable skills that lead to financial independence."
              baseAmount={womenBaseAmount}
              quantity={womenQuantity}
              onIncrease={handleWomenIncrease}
              onDecrease={handleWomenDecrease}
              onQuantityChange={handleWomenQuantityChange}
              totalAmount={womenTotalAmount}
              purpose={`Education for ${womenQuantity} woman${womenQuantity > 1 ? '' : ''} (3 months)`}
              behalf="Donation Options"
              behalfdescription="Choose how many women you want to empower"
              showQuantityControls={true}
              serviceType="women"
              buttonText="Donate for Women"
            />
          </div>
        </section>
      </div>
    </>
  );
};

export default IRCWOMEN;